<!-- eslint-disable vuejs-accessibility/click-events-have-key-events -->
<template>
  <v-card>
    <v-form>
      <v-card-title>
        <span class="headline">View Detail</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <data-detail-row
            label="Merchant"
            :slotData="true"
            :slotCol="true"
            noGutters
          >
            <template #value>
              <div v-if="editedItem.promo_type == 1">All Merchant</div>
              <div v-else>
                <a @click="listMerchant()" class="text-decoration-none"
                  >List Merchant</a
                >
              </div>
            </template>
          </data-detail-row>

          <data-detail-row
            label="Nama Promo"
            :data="editedItem"
            :valueData="editedItem.promo_name"
            noGutters
          />

          <data-detail-row
            label="QR Method"
            :slotData="true"
            :slotCol="true"
            noGutters
          >
            <template #value>
              <v-chip x-small v-if="editedItem.qr_method_npm == 1" class="mr-1">
                MPM
              </v-chip>
              <v-chip x-small v-if="editedItem.qr_method_cpm == 1" class="mr-1">
                CPM
              </v-chip>
            </template>
          </data-detail-row>
          <data-detail-row
            label="Payment Type"
            :slotData="true"
            :slotCol="true"
            noGutters
          >
            <template #value>
              <v-chip
                x-small
                v-if="editedItem.payment_type_on_us == 1"
                class="mr-1"
              >
                ON US
              </v-chip>
              <v-chip
                x-small
                v-if="editedItem.payment_type_off_us == 1"
                class="mr-1"
              >
                OFF US
              </v-chip>
            </template>
          </data-detail-row>

          <data-detail-row
            label="Minimum Transaksi"
            :data="editedItem"
            :valueData="editedItem.min_transaction"
            noGutters
          />
          <data-detail-row
            label="Periode Promo"
            :data="editedItem"
            :valueData="
              editedItem.start_datetime + ' - ' + editedItem.end_datetime
            "
            noGutters
          />
          <data-detail-row
            label="Promo per User"
            :data="editedItem"
            :valueData="
              editedItem.promo_quota_per_merchant + ' Promo / Merchant '
            "
            noGutters
          />
          <data-detail-row
            label=""
            :data="editedItem"
            :valueData="
              editedItem.promo_quota_per_customer + ' Promo / Customer '
            "
            noGutters
          />
          <data-detail-row
            label="Promo per Hari"
            :data="editedItem"
            :valueData="
              editedItem.promo_quota_merchant_per_day + ' Promo / Merchant '
            "
            noGutters
          />
          <data-detail-row
            label=""
            :data="editedItem"
            :valueData="
              editedItem.promo_quota_customer_per_day + ' Promo / Customer '
            "
            noGutters
          />

          <data-detail-row
            label="Jenis Promo"
            :slotData="true"
            :slotCol="true"
            noGutters
          >
            <template #value>
              {{ editedItem.jenis_promo == 1 ? 'Discount' : 'Cashback' }}
              <span v-if="editedItem.discount_type == 1">
                {{ editedItem.percent }} %, Maksimum Potongan
                {{ editedItem.max_discount_amount }}
              </span>
              <span v-else>
                {{ editedItem.fix_amount }}
              </span>
            </template>
          </data-detail-row>

          <data-detail-row
            label="Syarat dan Ketentuan"
            :data="editedItem"
            :valueData="editedItem.syarat_dan_ketentuan"
            noGutters
          />
          <data-detail-row
            label="Status"
            :data="editedItem"
            :valueData="editedItem.status"
            noGutters
          />
          <data-detail-row
            v-if="editedItem.check_bulk_failed"
            label="Bulk Failed"
            :slotData="true"
            :slotCol="true"
            noGutters
          >
            <template #value>
              <a
                @click="downloadFailed(editedItem.id, editedItem.bulk_id)"
                class="text-decoration-none"
                >List Merchant Failed</a
              >
            </template>
          </data-detail-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="close"> Cancel </v-btn>
      </v-card-actions>
    </v-form>

    <v-dialog v-model="dialogMerchant" max-width="500px">
      <merchant-promo
        v-on:closeParent="closeMerchant"
        :promoId="editedItem.id"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { date } from '../../lib/helpers';

export default {
  components: {
    MerchantPromo: () => import('../detail/MerchantPromo.vue'),
    DataDetailRow: () => import('../detail/DataDetailRow.vue'),
  },
  props: ['editedItem'],
  computed: {},
  data: () => ({
    dialogMerchant: false,
  }),
  methods: {
    close() {
      this.$emit('closeParent');
    },
    closeMerchant() {
      this.dialogMerchant = false;
    },
    downloadFailed(id, bulkId) {
      this.$store
        .dispatch('promo/downloadFailed', {
          date,
          promoId: id,
          bulkId,
        })
        .then((response) => {
          window.location.href = response.data;
        });
    },
    listMerchant() {
      this.dialogMerchant = true;
    },
  },
};
</script>
